module.exports = __webpack_public_path__ + "static/3-828a3b995e3d97448d63dbd54821b1bd.jpg";